import { ApiResult, httpRequest, Urls, httpFileRequest } from './Shared';

const PROPERTY_UNITS_URL = `${Urls.BASE_URL}/PropertyUnits`;

export interface propertyUnits {
    directions: any;
    id: number,
    pms_property_id: number,
    pms_property_name: string,
    pms_unit_id: string,
    pms_unit_display_name: string,
    unit_type: string,
    bed: number,
    bath: number,
    sqft: number,
    floor: string,
    model_unit: boolean,
    starting_price: number,
    lock_type: number,
    property_unit_type: number,
    show: boolean,
    access_enabled: boolean,
    beaconMajor: number,
    yardiLeaseStatus: string,
    yardiRentReady: boolean,
    entrataAvailabilityStatus: string,
    onesiteVacant: boolean,
    onesiteAvailable: boolean,
    onesiteMadeReady: boolean,
    syncUnitAvailability: boolean | null,
    // created: string,
    // updated: string,
    smartRentRemoteUnitId: string;
    available: boolean | undefined;
    keyCafeUnitKeys: any[];
}

export const getUnitListByPropertyId = (id: number): Promise<ApiResult<propertyUnits[]>> => {
    return httpRequest<propertyUnits[]>(`${PROPERTY_UNITS_URL}/getunitsbypropertyid/${id}`, 'get')
}

export const getIntegrationIdsByTypeAndPropertyId = (integrationType: string,id: number): Promise<ApiResult<[]>> => {
    return httpRequest<[]>(`${PROPERTY_UNITS_URL}/${integrationType}/getUnitDetailsByUnitName/${id}`, 'get')
}

export const updateUnit = (propertyId: number, unit: propertyUnits) => {
    return httpRequest<propertyUnits[]>(`${PROPERTY_UNITS_URL}/${propertyId}`, 'put', unit)
}

export const addUnit = (propertyId: number, unit: propertyUnits) => {
    return httpRequest(`${PROPERTY_UNITS_URL}/${propertyId}`, 'post', unit)
}

export const deleteUnit = (id: number) => {
    return httpRequest(`${PROPERTY_UNITS_URL}/${id}`, 'delete')
}

export const uploadCSV = (propertyId: number, data: FormData) => {
    debugger;
    return httpFileRequest(`${PROPERTY_UNITS_URL}/uploadpropertyunits/${propertyId}`,
        'post',
        data,
        true);
}


// WEBPACK FOOTER //
// ./src/api/PropertyUnits.ts